import { AllMeetingsList } from "../components/AllMeetingsList";
import { useAuth } from "../contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { meetingsService } from "../services/supabase/meetings";
import React from "react";

const MeetingsList = () => {
  const { user } = useAuth();

  const { data: meetings, isLoading, error } = useQuery({
    queryKey: ['meetings', user?.id],
    queryFn: () => meetingsService.getMeetings(user?.id!),
    enabled: !!user?.id
  });

  return (
    <div className="space-y-6 p-4">
      <div className="flex flex-col space-y-4">
        <h1 className="text-3xl font-bold">Recent Meetings</h1>
      </div>
      <AllMeetingsList 
        meetings={meetings || []} 
        isLoading={isLoading} 
        error={error instanceof Error ? error : undefined} 
      />
    </div>
  );
};

export default MeetingsList;